var module = 'main', name = 'main/components/appointment-attachments/appointment-attachments.html', content = "<div class=\"container\"><span class=\"clip-icon\"></span> <span class=\"title\" translate=\"home.upcoming.attachments.title\"></span><div class=\"attached-files\"><div class=\"attached-file\" ng-repeat=\"file in ::$ctrl.appointment.attachments\"><span ng-click=\"$ctrl.openAttachment(file)\">{{::file.file}}</span> <span ng-bind-html=\"::('&nbsp;&nbsp;(' + (file.size | bytesSize) + ')')\"></span></div></div></div>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/components/appointment-attachments/appointment-attachments.html
// module id = 1322
// module chunks = 0